import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';
import { Box, Button, Paper, Typography } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ImageView from './imageView';
import { tokens } from '../../theme';

const imageFormats = ['jpg', 'png', 'jpeg', 'gif'];
const isImage = (url) => imageFormats.includes(String(url).split('.').pop().toLowerCase());

class InvoiceAttachmentsView extends Component {
    state = { previewPath: '', attachments: [] };

    componentDidMount() {
        const value = queryString.parse(this.props.location.search);
        this.bindInvoiceAttachments(value.date, value.id);
    }

    bindInvoiceAttachments = (cDate, iNo) => {
        const listData = (this.props.invoiceList || []).filter(
            (item) => moment(item.createdDate).format('YYYY/MM/DD') === moment(cDate).format('YYYY/MM/DD')
        );
        const attachments = [];
        listData.forEach((item) => {
            Object.keys(item.attachments || {}).forEach((invNo) => {
                if (String(invNo) === String(iNo)) attachments.push(...item.attachments[invNo]);
            });
        });
        this.setState({ attachments });
    };

    render() {
        const { attachments, previewPath } = this.state;
        if (attachments.length === 0) {
            return (
                <Paper variant="outlined" sx={{ py: 6, textAlign: 'center' }}>
                    <Typography color="text.secondary">No attachments found for this invoice.</Typography>
                </Paper>
            );
        }
        return (
            <>
                <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))' }}>
                    {attachments.map((att, index) => (
                        <Paper key={`${att.attachmentURL}-${index}`} variant="outlined" sx={{ overflow: 'hidden' }}>
                            <Box
                                sx={{
                                    height: 160,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: tokens.workspace,
                                }}
                            >
                                {isImage(att.attachmentURL) ? (
                                    <img src={att.attachmentURL} alt="" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                ) : (
                                    <PictureAsPdfOutlinedIcon sx={{ fontSize: 64, color: tokens.red }} />
                                )}
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, p: 1, borderTop: `1px solid ${tokens.line}` }}>
                                {isImage(att.attachmentURL) && (
                                    <Button size="small" startIcon={<ZoomInIcon />} onClick={() => this.setState({ previewPath: att.attachmentURL })}>
                                        View
                                    </Button>
                                )}
                                <Button size="small" startIcon={<FileDownloadOutlinedIcon />} onClick={() => window.open(att.attachmentURL)}>
                                    Open
                                </Button>
                            </Box>
                        </Paper>
                    ))}
                </Box>
                <ImageView imagePath={previewPath} lightboxIsOpen={Boolean(previewPath)} closeLightbox={() => this.setState({ previewPath: '' })} />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    invoiceSelectedDate: state.invoiceSelectedDate,
    invoiceList: state.invoiceList.formattedList,
});

export default withRouter(connect(mapStateToProps)(InvoiceAttachmentsView));
